import React, { Component } from "react";
import { Box } from "@mui/material";
import Spinner from "react-bootstrap/Spinner";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Cookies from "js-cookie";
import settings from "../../helpers/settings";
import axios from "axios";
import Modal from "@mui/material/Modal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "react-bootstrap/Button";
import { Navigate } from "react-router-dom";
import PreAuthorization from "../Authorization/PreAuthorization.js";
import Accordion from "react-bootstrap/Accordion";
import { FormControl } from "@mui/material";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Patient from "./../patient";

let { KayanURL } = settings;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
  AuthScreen: false,
};
const allInsuraceCompanies = {
  "LICNS-00007": "OQIC Test (LICNS-00007)",
  "NI/23": "LIVA prod (NI/23)",
  "NI/32": "OQIC Prod (NI/32)",
  "FI/9": "New India Prod (FI/9)",
  "LICNS-00001": "AXA Test (LICNS-00001)",
  "LICNS-00014": "Mednet Test (LICNS-00014)",
  "FI/6": "AXA Prod (FI/6)",
  "TPA/004": "Mednet Prod (TPA/004)",
  "LICNS-202315": "New India Test (LICNS-202315)",
  "LICNS-2023156": "Damana Test (LICNS-2023156)",
  "TPA/003": "Vipul Prod (TPA/003)",
  "FI/35": "Damana Prod (FI/35)",
  "LICNS-202329": "Vipul Test (LICNS-202329)",
  "FI/15": "Metlife Prod (FI/15)",
  "TPA/001": "Greenline Prod (TPA/001)",
  "FI/15": "Metlife (FI/15)",
  "LICNS-00013": "Nextcare Test (LICNS-00013)",
  "TPA/002": "Nextcare Prod (TPA/002)",
  "NI/37": "Takaful Oman Insurance Company",
  "LICNS-202314": "MetLife (LICNS-202314)",

  "NI/33": "Arabia Flacon(NI/33)",
  "FI/32": "Sukoon(FI/32)",
  "NI/38": "Muscat (NI/38)",
  "FI/34": "Orient (FI/34)",
  "NI/21": "Dhofar (NI/21)",
  "NI/34": "AlMadina (NI/34)",
  "NI/20": "OmanUnited (NI/20)",

};

class Eligibilityhistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToAuth: false,
      eligibilityHistoryScreen: true,
      searchInfo: {},
      searchFound: false,
      loading: true,
      offset: 0,
      totalPatients: 0,
      loadingRowIndex:null
    };
  }
  componentDidMount = async () => {
    // await this.getPatients();
    this.getAllPatientEligibilityInfo();
    this.geTUesrInfo();
  };

  getAllPatientEligibilityInfo = async () => {
    this.setState({
      loading: true,
      errMsg: "",
    });

    try {
      let response = await axios.put(
        KayanURL + "/test/patients/getEligibilityInfo",
        {
          apiToken: Cookies.get("id"),
        }
      );

      if (response) {
        let { data } = response;
        // console.log(data, "daaaaaaaaaaaaata");
        if (data) {
          let { success, eligibilityHistory } = data;

          if (success) {
            console.log(eligibilityHistory.length, 'length')
            let sortedEligibilityHistory = eligibilityHistory.sort((a, b) => b.id - a.id);

            let totalPatients = sortedEligibilityHistory.length;

            let paginatedEligibilityHistory = sortedEligibilityHistory.slice(
              this.state.offset,
              this.state.offset + 20
            );
            this.setState({
              allPatients: paginatedEligibilityHistory,
              totalPatients: totalPatients
            });

            // if (paginatedEligibilityHistory.length === 0) {
            //   alert("You reached at the end ");
            // }
          } else {
            this.setState({
              allPatients: [],
              searchFound: false,
              name: "",
              payer_name: "",
              disposition: "",
              searchInfo: {},

            });
            // alert("There is No Rows Found!");
          }
        }
      }
    } catch (error) {
      console.error("Error fetching patient eligibility info:", error);
    } finally {
      this.setState({
        loading: false,
        searchFound: false,
      });
    }
  };

  handleNext = () => {
    this.setState(
      prevState => ({ offset: prevState.offset + 20 }),
      () => {
        this.getAllPatientEligibilityInfo();
      }
    );
  };

  handlePrevious = () => {
    this.setState(
      prevState => ({ offset: Math.max(prevState.offset - 20, 0) }),
      () => {
        this.getAllPatientEligibilityInfo();
      }
    );
  };

  geTUesrInfo = async () => {
    let response = await axios.put(
      KayanURL + "/test/users/getUserInfo",

      {
        apiToken: Cookies.get("id"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        let { providerDhamaniID } = data;
        this.setState({ providerDhamaniID });
      }
    }
  };
  showEligibilityInfo = async (index,element) => {
    let coverageInfo;
    let patientInfo;
    if (element) {
      this.setState({ loadingRowIndex: index });
      let response = await axios.put(
        KayanURL + "/test/patients/getEligibilityInfoByID",
        {
          apiToken: Cookies.get("id"),
          eligibilityID: element.id
        }
      );


      if (response) {
        let { data } = response;
        if (data) {
          console.log(data)
          let { success, eligibilityInfoByID } = data;
          if (success) {
            this.setState({ loadingRowIndex:null })
            if (eligibilityInfoByID && eligibilityInfoByID.length > 0) {
              let element = eligibilityInfoByID[0];
              if (element.coverage) {
                if (typeof element.coverage === "string") {
                  coverageInfo = JSON.parse(element.coverage);
                  coverageInfo["disposition"] = element.disposition;
                } else {
                  coverageInfo = element.coverage;
                  coverageInfo["disposition"] = element.disposition;
                }
              }
              patientInfo = {
                BirthDate: element.birthdate,
                Company_id: element.company_id,
                Country: element.country,
                Coverage: element.coverage,
                Disposition: element.disposition,
                employeeid: element.employee_id,
                firstname: element.first_name,
                last_name: element.last_name,
                Gender: element.gender,
                id: element.id,
                identifier: element.identifier,
                identifier_type: element.identifier,
                insurance: element.insurance,
                items: element.items,
                patient_id: element.patient_id,
                payer_id: element.payer_id,
                payer_name: element.payer_name,
                phone: element.phone,
                profile_id: element.profile_id,
                provider_id: element.provider_id,
                provider_name: element.provider_name,
                service_date: element.service_date,
              };

              this.setState({
                showEligibilityInfoModal: true,
                coverageInfo: coverageInfo,
                items:
                  typeof element.items === "string"
                    ? JSON.parse(element.items)
                    : element.items,
                selectedPatient: element,
                patientInfo: patientInfo,
              });
            }
          }
        }
      }


    }
  };
  handleCloseEligibilityInfoModal = () => {
    this.setState({ showEligibilityInfoModal: false });
  };

  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };
  openPreAuthScreen = (e) => {
    this.setState({
      AuthScreen: true,
      eligibilityHistoryScreen: false,
    });
  };
  HandleInputSearchRequestTextChange = (e) => {
    let name = e.target.name;
    console.log(name, "name");
    let value = e.target.value;
    console.log(value, "value");
    let patientName,
      patientLastName = "";
    if (name === "name") {
      patientName = value.trim().split(" ");
      if (patientName.length > 1) {
        for (let i = 1; i < patientName.length; i++) {
          patientLastName += patientName[i] + " ";
        }
        this.setState({
          searchInfo: {
            ...this.state.searchInfo,
            first_name: patientName[0],
            last_name: patientLastName.trim(),
          },
          name: value,
        });
      } else {
        this.setState({
          searchInfo: {
            ...this.state.searchInfo,
            first_name: patientName[0],
            last_name: "",
          },
          name: value,
        });
      }
    } else {
      this.setState({
        searchInfo: { ...this.state.searchInfo, [name]: value },
        [name]: value,
      });
    }
  };
  handleSearchRequest = async () => {
    let { searchInfo, allPatients } = this.state;
    if (Object.keys(searchInfo).length === 0 || searchInfo === undefined) {
      this.setState({ errMsg: "Please select a value to search" });
    }
    for (let key in searchInfo) {
      if (!searchInfo.hasOwnProperty(key) && searchInfo[key] === "") {
        this.setState({ errMsg: "Please select a value to search" });
      } else {
        this.setState({
          searchRequestSent: true,
          searchDone: false,
          errMsg: "",
        });
        let selectedPatients = allPatients.filter((patient) => {
          for (const key in searchInfo) {
            const searchValue = searchInfo[key].toLowerCase();
            const patientValue = patient[key]?.toLowerCase() || "";

            if (!patientValue.includes(searchValue)) {
              return false;
            }
            return true;
          }
        });
        if (selectedPatients && selectedPatients.length > 0) {
          this.setState({ allPatients: selectedPatients });
          setTimeout(() => {
            this.setState({
              searchRequestSent: false,
              searchDone: true,
              searchFound: true,
            });
          }, 500);
        } else {
          this.setState({ name: "", payer_name: "", disposition: "" });
          this.setState({
            allPatients: allPatients,
            errMsg: "No patient with this information...",
          });
          setTimeout(() => {
            this.setState({
              searchRequestSent: false,
              searchDone: true,
            });
          }, 500);
        }
        this.setState({ name: "", payer_name: "", disposition: "" });

        console.log("Selected Patients:", selectedPatients);
      }
    }
  };
  render() {
    const { loading, loadingShowMore } = this.state;
    console.log(this.state.searchInfo, "searchInfo");

    let { coverageInfo, allPatients, items, patientInfo } = this.state;
    let insuranceItemRows = [];
    let PatientRows = [];
    let CoverageData;
    let PatientInfoRows;
    let itemRows;
    let itemShow = false;
    // console.log(allPatients, "alllllllllll");

    if (items && items.length > 0) {
      insuranceItemRows = items.map((element, index) => {
        if (element.item && element.item.length > 0) {
          let benefitRows;
          itemShow = true;
          itemRows = element.item.map((element, index) => {
            if (element.benefit)
              benefitRows = element.benefit.map((element, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell align="center" style={{ fontSize: "10px" }}>
                      {element.type}
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "10px" }}>
                      {element.allowedMoney}
                    </TableCell>
                  </TableRow>
                );
              });
            else benefitRows = <></>;
            return (
              <TableRow key={index}>
                <TableCell align="center" style={{ fontSize: "10px" }}>
                  {element.name}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "10px" }}>
                  {element.description}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "10px" }}>
                  {element.category}{" "}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "10px" }}>
                  {element.excluded ? "True" : "False"}{" "}
                </TableCell>

                <TableCell align="center" style={{ fontSize: "10px" }}>
                  {element.network}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "10px" }}>
                  {element.unit}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "10px" }}>
                  {element.term}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "10px" }}>
                  <TableContainer
                    component={Paper}
                    style={{
                      margin: "auto",
                      width: "100%",
                    }}
                  >
                    <Table aria-label="simple table">
                      <TableHead style={{ backgroundColor: "#fafafa" }}>
                        <TableRow style={{ textAlign: "center" }}>
                          <TableCell
                            align="center"
                            style={{ fontSize: "10px" }}
                          >
                            Type
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: "10px" }}
                          >
                            allowed Money
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>{benefitRows}</TableBody>
                    </Table>
                  </TableContainer>
                </TableCell>
              </TableRow>
            );
          });
        }

        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {element.coverageURL}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {element.inforce ? "True" : "False"}
            </TableCell>
            {element.item && element.item.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "10px" }}>
                <TableContainer
                  component={Paper}
                  style={{
                    margin: "auto",
                  }}
                >
                  <Table aria-label="simple table">
                    <TableHead style={{ backgroundColor: "#fafafa" }}>
                      <TableRow style={{ textAlign: "center" }}>
                        <TableCell align="center" style={{ fontSize: "10px" }}>
                          Name
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "10px" }}>
                          Description
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "10px" }}>
                          Category
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "10px" }}>
                          Excluded
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "10px" }}>
                          Network
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "10px" }}>
                          Unit
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "10px" }}>
                          Term
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "10px" }}>
                          Benefit
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{itemRows}</TableBody>
                  </Table>
                </TableContainer>
              </TableCell>
            ) : null}
          </TableRow>
        );
      });
    }
    if (allPatients && allPatients.length > 0) {
      const convertToOmanTime = (utcFormattedDate) => {
        const utcDate = new Date(utcFormattedDate);
        utcDate.setUTCHours(utcDate.getUTCHours() + 4);
        const omanFormattedDate = `${utcDate.getFullYear()}-${String(
          utcDate.getMonth() + 1
        ).padStart(2, "0")}-${String(utcDate.getUTCDate()).padStart(2, "0")}
            T${String(utcDate.getUTCHours()).padStart(2, "0")}:${String(
          utcDate.getUTCMinutes()
        ).padStart(2, "0")}`;
        return omanFormattedDate;
      };
      //mmmmmmmmmmmmm
      const sortedByID = allPatients
        .map((patient, index) => ({
          index,
          patient,
        }))
        .sort((a, b) =>
          new Date(b.patient.formatteddatetime)
            .toISOString()
            .localeCompare(new Date(a.patient.formatteddatetime).toISOString())
        ).map((pair) => pair.patient);
      PatientRows = sortedByID.map((element, index) => {
        const omanTime = new Date(element.formatteddatetime).toLocaleString(
          "en-US",
          { timeZone: "Asia/Muscat" }
        ); //convertToOmanTime(element.formatteddatetime);
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {element.first_name} {element.last_name}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {element.profile_id}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {allInsuraceCompanies[element.payer_name]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {/* {this.state.providerDhamaniID} */}
              {element.provider_name}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {element.service_date}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {/* {element.disposition ? element.disposition:"Coverage is not inforce"} */}
              {element.disposition}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              {omanTime}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "13px" }}>
              <a
                onClick={(e) => {
                  this.showEligibilityInfo(index,element);
                }}
                style={{ cursor: "pointer" }}
              >
                {this.state.loadingRowIndex === index ? (
                  <>
                    <Spinner style={{fontSize:"10px",color: "grey"}} animation="border" variant="success" />
                  </>
                ) : (
                  <VisibilityIcon style={{ color: "grey", fontSize: "15px" }} />
                )}
              </a>
            </TableCell>
          </TableRow>
        );
      });
    }
    if (patientInfo) {
      PatientInfoRows = (
        <>
          <TableRow key={patientInfo.id}>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.BirthDate}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.Country}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.Disposition}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.firstname}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.last_name}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.Gender}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.identifier}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.identifier_type}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.insurance}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.patient_id}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.payer_id}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.payer_name}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.phone}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.profile_id}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.provider_id}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.provider_name}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {patientInfo.service_date}{" "}
            </TableCell>
          </TableRow>
        </>
      );
    }

    if (coverageInfo) {
      CoverageData = (
        <>
          <TableRow key={coverageInfo.id}>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.bundleId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.class[0].type}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.class[0].value}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.coverageEligibilityRequestId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.fullUrl}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.id}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.memberid}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.messageId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.patientId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.relationship}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.status}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {/* {coverageInfo.disposition ? coverageInfo.disposition:"Coverage is not inforce"} */}
              {coverageInfo.disposition}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.period.start}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "10px" }}>
              {coverageInfo.period.end}{" "}
            </TableCell>
          </TableRow>
        </>
      );
    }
    return (
      <>
        <Box height={60} />
        {this.state.eligibilityHistoryScreen ? (
          <>
            <div
              style={{
                textAlign: "left",
                boxShadow: "1px solid grey",
                padding: "15px",
                boxShadow:
                  "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                borderRadius: "10px",
              }}
            >
              <div>
                <div style={{ width: "90%", margin: "auto", padding: "20px" }}>
                  <Accordion
                    defaultActiveKey="0"
                    style={{
                      margin: "auto",
                      paddingBottom: "0px",
                      width: "80%",
                    }}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <span style={{ color: "grey" }}>Search Claim</span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Patient Name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="name"
                                value={this.state.name ? this.state.name : ""}
                                required
                                onChange={
                                  this.HandleInputSearchRequestTextChange
                                }
                                placeholder="Enter Patient Name"
                              />
                            </Form.Group>

                            <div style={{ width: "100%" }}>
                              <Button
                                variant="contained"
                                style={{
                                  width: "50%",
                                  backgroundColor: "rgb(97 110 120",
                                  marginRight: "10px",
                                  color: "white",
                                }}
                                onClick={(e) => this.handleSearchRequest(e)}
                              >
                                search
                              </Button>
                              <Button
                                variant="contained"
                                style={{
                                  backgroundColor: "rgb(97 110 120",
                                  marginRight: "10px",
                                  color: "white",
                                }}
                                onClick={this.getAllPatientEligibilityInfo}
                              >
                                Back
                              </Button>
                            </div>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Payer Name
                              </Form.Label>
                              <Form.Select
                                onChange={
                                  this.HandleInputSearchRequestTextChange
                                }
                                required
                                value={
                                  this.state.payer_name
                                    ? this.state.payer_name
                                    : ""
                                }
                                name="payer_name"
                              >
                                <option value="0">select...</option>
                                <option value="LICNS-202315">
                                  New India Test (LICNS-202315)
                                </option>
                                <option value="LICNS-00007">
                                  OQIC Test (LICNS-00007)
                                </option>
                                <option value="LICNS-00001">
                                  AXA Test (LICNS-00001)
                                </option>
                                <option value="LICNS-00014">
                                  Mednet Test (LICNS-00014)
                                </option>
                                <option value="LICNS-202329">
                                  Vipul Test (LICNS-202329)
                                </option>
                                <option value="LICNS-2023156">
                                  Damana Test (LICNS-2023156)
                                </option>

                                <option value="NI/23">
                                  LIVA prod (NI/23){" "}
                                </option>
                                <option value="FI/9">
                                  New India Prod (FI/9)
                                </option>
                                <option value="NI/32">OQIC Prod (NI/32)</option>
                                <option value="FI/6">AXA Prod (FI/6)</option>
                                <option value="TPA/004">
                                  Mednet Prod (TPA/004)
                                </option>
                                <option value="TPA/003">
                                  Vipul Prod (TPA/003)
                                </option>
                                <option value="FI/35">
                                  Damana Prod (FI/35)
                                </option>
                                <option value="FI/15">
                                  Metlife Prod (FI/15)
                                </option>
                                <option value="TPA/001">
                                  Greenline Prod (TPA/001)
                                </option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Status
                              </Form.Label>
                              <Form.Select
                                onChange={
                                  this.HandleInputSearchRequestTextChange
                                }
                                required
                                value={
                                  this.state.disposition
                                    ? this.state.disposition
                                    : ""
                                }
                                name="disposition"
                              >
                                <option value="0">select...</option>
                                <option value="Coverage is in-force">
                                  Coverage is in-force
                                </option>
                                <option value="Coverage is not in-force">
                                  Coverage is not in-force
                                </option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          {this.state.errMsg ? (
                            <>
                              <Typography
                                style={{ textAlign: "center", color: "red" }}
                              >
                                {this.state.errMsg}
                              </Typography>
                            </>
                          ) : null}
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  {this.state.searchRequestSent && !this.state.searchDone ? (
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                      <Spinner animation="border" variant="success" />
                    </div>
                  ) : this.state.searchDone && this.state.error ? (
                    <h5 style={{ color: "red", textAlign: "center" }}>
                      {this.state.error}
                    </h5>
                  ) : null}
                </div>
                <div style={{ width: "100%", margin: "auto", padding: "20px" }}>
                  <div>
                    {loading ? (
                      <div style={{ textAlign: "center", marginTop: "30px" }}>
                        <Spinner animation="border" variant="success" />
                      </div>
                    ) : (
                      <>
                        {allPatients && allPatients.length > 0 ? (
                          <>
                            <hr />
                            <TableContainer
                              component={Paper}
                              style={{
                                margin: "auto",
                                marginTop: "30px",
                                width: "100%",
                              }}
                            >
                              <Table aria-label="simple table">
                                <TableHead
                                  style={{ backgroundColor: "#fafafa" }}
                                >
                                  <TableRow style={{ textAlign: "center" }}>
                                    {/* <TableCell align="center">ID</TableCell> */}
                                    <TableCell align="center">Name</TableCell>
                                    <TableCell align="center">
                                      Patient ID
                                    </TableCell>
                                    <TableCell align="center">
                                      Payer Name
                                    </TableCell>
                                    <TableCell align="center">
                                      Provider Name
                                    </TableCell>
                                    <TableCell align="center">
                                      Service Date
                                    </TableCell>
                                    <TableCell align="center">Status</TableCell>
                                    <TableCell align="center">Time</TableCell>
                                    <TableCell align="center">
                                      Show More
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>{PatientRows}</TableBody>
                              </Table>
                            </TableContainer>
                            {!this.state.searchFound ? (
                              <>
                                <Button variant="contained"
                                  style={{
                                    width: "10%",
                                    backgroundColor: "rgb(97 110 120",
                                    marginTop: "10px",
                                    color: "white",
                                    marginRight: "10px",
                                  }}
                                  onClick={this.handlePrevious}
                                  disabled={this.state.loading || this.state.offset === 0}
                                >
                                  Previous
                                </Button>
                                <Button variant="contained"
                                  style={{
                                    width: "10%",
                                    backgroundColor: "rgb(97 110 120",
                                    marginTop: "10px",
                                    color: "white",
                                  }}
                                  onClick={this.handleNext}
                                  disabled={this.state.loading || this.state.offset + 20 >= this.state.totalPatients}
                                >
                                  Next
                                </Button>
                              </>
                            ) : null}

                          </>
                        ) : (
                          <h5 style={{ color: "red", textAlign: "center" }}>
                            There is No Rows Found!
                          </h5>
                        )}
                      </>
                    )}
                    {this.state.searchFound ? (
                      <>
                        <div style={{ width: "100%" }}>
                          <Button
                            variant="contained"
                            style={{
                              width: "10%",
                              backgroundColor: "rgb(97 110 120",
                              marginTop: "10px",
                              color: "white",
                            }}
                            onClick={(e) =>
                              this.getAllPatientEligibilityInfo(e)
                            }
                          >
                            clear filter
                          </Button>
                        </div>
                      </>
                    ) : null}
                    {this.state.showEligibilityInfoModal ? (
                      <>
                        <Modal
                          open={this.state.showEligibilityInfoModal}
                          onClose={this.handleCloseEligibilityInfoModal}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <Box
                            sx={style}
                            style={{
                              width: "85%",
                              height: "85%",
                              overflowY: "scroll",
                            }}
                          >
                            {PatientInfoRows ? (
                              <>
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "center" }}
                                >
                                  Patient Info
                                </Typography>
                                <TableContainer
                                  component={Paper}
                                  style={{
                                    margin: "auto",
                                    marginTop: "30px",
                                    width: "100%",
                                  }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow style={{ textAlign: "center" }}>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          BirthDated
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Country
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          {" "}
                                          Disposition
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          firstname
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          last_name
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Gender
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          identifier
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          identifier_type
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          insurance
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          patient_id
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          payer_id
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          payer_name
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          phone
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          profile_id
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          provider_id
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          provider_name
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          service_date
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>{PatientInfoRows}</TableBody>
                                  </Table>
                                </TableContainer>
                              </>
                            ) : null}
                            {CoverageData ? (
                              <>
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "center" }}
                                >
                                  Coverage Info
                                </Typography>
                                <TableContainer
                                  component={Paper}
                                  style={{
                                    margin: "auto",
                                    marginTop: "30px",
                                    width: "100%",
                                  }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow style={{ textAlign: "center" }}>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          bundle ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Class Type
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Class Value
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          {" "}
                                          Coverage Eligibility Request ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Full URL
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Coverage ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Member ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Message ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Patient ID
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Relationship
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Status
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Disposition
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Start Data
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          End Data
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>{CoverageData}</TableBody>
                                  </Table>
                                </TableContainer>
                              </>
                            ) : null}

                            {items && items.length > 0 ? (
                              <>
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "center" }}
                                >
                                  Insurance Items
                                </Typography>
                                <TableContainer
                                  component={Paper}
                                  style={{
                                    margin: "auto",
                                    marginTop: "30px",
                                    width: "100%",
                                  }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow style={{ textAlign: "center" }}>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Coverage URL
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "10px" }}
                                        >
                                          Inforce
                                        </TableCell>
                                        {itemShow ? (
                                          <TableCell
                                            align="center"
                                            style={{ fontSize: "10px" }}
                                          >
                                            Items
                                          </TableCell>
                                        ) : null}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>{insuranceItemRows}</TableBody>
                                  </Table>
                                </TableContainer>
                              </>
                            ) : null}
                            {this.state.selectedPatient.coverage ? (
                              <>
                                <div style={{ marginTop: "15px" }}>
                                  <Button
                                    variant="primary"
                                    type="submit"
                                    onClick={(e) => this.openPreAuthScreen(e)}
                                    style={{
                                      width: "25%",
                                      marginTop: "32px",
                                      backgroundColor: "rgb(78 75 75)",
                                      border: "1px solid rgb(78 75 75)",
                                    }}
                                  >
                                    PreAuthorization
                                  </Button>
                                </div>
                              </>
                            ) : null}
                          </Box>
                        </Modal>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}

        {this.state.AuthScreen && !this.state.eligibilityHistoryScreen ? (
          <>
            <PreAuthorization
              selectedPatient={this.state.selectedPatient}
              flag="true"
            />
          </>
        ) : null}
      </>
    );
  }
}
export default Eligibilityhistory;
